<template>
  <div class="login">
    <div class="title">
      <!-- <dy-image :src="require('../../assets/images/logo.png')"></dy-image> -->
      智慧社区管理系统
    </div>
    <a-form-model ref="form" :model="form" layout="vertical" :rules="rules">
      <a-form-model-item label="账号" prop="phone">
        <a-input size="large" v-model="form.phone" placeholder="请输入账号" allow-clear></a-input>
      </a-form-model-item>
      <a-form-model-item label="密码" prop="password">
        <a-input size="large" v-model="form.password" placeholder="请输入密码" allow-clear type="password"></a-input>
      </a-form-model-item>
      <a-form-model-item label="验证码" prop="code" ref="code">
        <a-space>
          <a-input size="large" v-model="form.code" placeholder="请输入验证码" allow-clear
            @blur="() => { $refs.code.onFieldBlur() }" @change="() => { $refs.code.onFieldChange() }"></a-input>
          <dy-image size="large" :src="codeImg.src" code-type @click="initCodeImg"></dy-image>
        </a-space>
      </a-form-model-item>
      <a-form-model-item>
        <a-button size="large" type="primary" block @click="submit">确定</a-button>
        <a-row type="flex" justify="end">
          <a-button type="link" @click="showRegion('forgetPassword')">忘记密码</a-button>
        </a-row>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import UserService from '@/io/user.js';
import GoodsTypeService from '@/io/goods_type.js'

export default {
  name: 'Login',
  data() {
    return {
      codeImg: {
        src: null,
        key: null
      },
      form: {
        phone: null,
        password: null,
        code: null
      },
      rules: {
        phone: [
          {
            required: true,
            message: '请填写手机号'
          }
        ],
        password: [
          {
            required: true,
            message: '请填写密码'
          }
        ],
        code: [
          {
            required: true,
            message: '请填写验证码'
          }
        ]
      }
    }
  },
  mounted() {
    this.initCodeImg();
  },
  methods: {
    submit() {
      this.$beforeFormSubmit(this.$refs.form, () => {
        UserService.login(
          this.form.phone,
          this.form.password,
          this.codeImg.key,
          this.form.code
        ).then(res => {
          this.$afterFormSubmit('登录成功', () => {
            this.$setCookie('token', `${res.token_type} ${res.access_token}`);

            // 为了解决掉用第三方商城服务登录并发token冲突的问题，先掉用一个接口保证登录成功
            GoodsTypeService.list(1, 1)
            this.$router.replace('/blank');
          });
        }).catch(err => { });
      });
    },
    showRegion(name) {
      this.$emit('showRegion', name);
    },
    initCodeImg() {
      UserService.codeImg().then(res => {
        this.codeImg.src = res.img;
        this.codeImg.key = res.key;
      }).catch(err => { });
    }
  },
}
</script>

<style lang="less" scoped>
@import "../../assets/styles/tools.less";

.login {
  .title {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: @font-size-base + 10px;
    margin-bottom: @padding-lg;
    font-weight: bold;

    .dy-image {
      width: 36px;
      height: 36px;
      margin-right: @padding-xs;
    }
  }

  .ant-form {
    .ant-form-item {
      &:nth-of-type(3) {
        .ant-form-item-control-wrapper {
          .ant-form-item-control {
            .ant-form-item-children {
              .ant-space {
                .ant-space-item {
                  &:nth-of-type(1) {
                    flex: 1;
                  }

                  &:nth-of-type(2) {
                    .dy-image {
                      width: auto;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>